import rxios from '../common/rxios'
import { map } from 'rxjs/operators'

export const geoipService = {
  getGeoip$() {
    return rxios.get(`${domain.homepage}/homepage/v1/geoip`).pipe(map(response => response.data.country))
  }
}
